import LanguageRequestProcessor from './request-processor-language'
import { settings } from '../../../settings/settings-util'

export default class LanguageManager {

    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._reqProc = new LanguageRequestProcessor(this._settings);
    }

    static getDefaultSettings() {
        return settings;
    }

    getRequestProcessor() {
        return this._reqProc;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/language/src/language.js